import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { SetupProject, SetupProjectCondition } from 'models/setup/SetupProject';
import { callApi } from 'utils/ApiUtil';

export const getSetupProjectList = async (condition: SetupProjectCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/getSetupProjectList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<SetupProject[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProject[];
};

export const findProject = async (condition?: SetupProjectCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...(condition || {}),
    }),
  };
  const response: CommonResponse<SetupProject[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProject[];
};

export const findProjectById = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project/${elmPrjId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<SetupProject> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProject;
};

export const findAssignedProject = async (condition?: SetupProjectCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/assigned-project`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<SetupProject[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProject[];
};

export const saveProject = async (masterData: SetupProject | undefined) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/project`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

export const getElmPrjIdNew = async (condition: SetupProjectCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/getElmPrjIdNew`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<string> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as string;
};

export const getProjectManagerList = async (condition: SetupProjectCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/getProjectManagerList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<SetupProject[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProject[];
};

/**
 * 프로젝트 담당자 권한 체크
 * @param elmPrjId(프로젝트 ID)
 * @param mgrType(권한 조회 조건(ALL/HQ/COP/HQCOP/EXCP))
 */
export const checkAvailableProjectManager = async (elmPrjId: string, mgrType: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project/check-auth`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ elmPrjId: elmPrjId, mgrType: mgrType }),
  };
  const response: CommonResponse = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : false) as boolean;
};

/**
 * 프로젝트 Bookmark
 * @param elmPrjId(프로젝트 ID)
 * @param mgrType(권한 조회 조건(ALL/HQ/COP/EXCP))
 */
export const saveProjectBookmark = async (condition: SetupProject) => {
  const request: CommonRequest = {
    method: Method.PUT,
    url: `/v1/setup/project/bookmark`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };

  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 화면노출용 프로젝트 조회 (임시저장x)
 * @param condition
 */
export const findDisplayProject = async (condition?: SetupProjectCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/display-project`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...(condition || {}),
    }),
  };
  const response: CommonResponse<SetupProject[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProject[];
};
